<template>
    <div id="infoBox" class="infoBox">
        <p id="pointName">Name: {{ name }}</p>
        <p id="pointType">Type: {{ type }}</p>
        <p>Date: {{ this.stringDate }}</p>
        <p>Height: {{ height }}</p>
        <p>Volume: {{ volume }}</p>
    </div>
</template>

<script lang="ts">
export default {
    name: 'PointInfo',
    props: {
        source: Object,
        date: Date
    },
    data() {
        return {
            name: "",
            type: "",
            measurement: null,
            volume: "",
            height: ""
        }
    },
    computed: {
        stringDate() {
            if (this.date != null && this.source != null) return this.date.toLocaleDateString();
            return "";
        }
    },
    methods: {
        setInfo() {
            if (this.source != null) {
                this.name = this.source.name
                this.type = this.source.type

                var measurements = this.source.measurements
                console.log("showing measurement: " + this.measurement)

                this.measurement = measurements[0]
                this.volume = this.measurement.volume
                this.height = this.measurement.height
            } else {
                this.name = ""
                this.type = ""
                this.volume = ""
                this.height = ""
            }
        }
    },
    watch: {
        source: function(newVal, old) {
            console.log("source changed from " + old + " to " + newVal)
            console.log("Date is: " + this.date)
            this.setInfo()
        }
    }
};
</script>

<style lang="scss" scoped>
$blue: #0079c1;
$gray: #959595;
$white: #fff;

header {
    background-color: $blue;
    color: $white;
    width: 100%;
    height: 2rem;
    line-height: 2rem;
    position: relative;
    font-weight: 400;
    font-style: normal;
    border-bottom: 1px solid $gray;
    text-align: center;
    span {
        vertical-align: middle;
    }
}
</style>
